import { CKEditor } from "@ckeditor/ckeditor5-react";
import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
import _ from "lodash";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { withParagraphTools } from "../../../../utils/ckEditorUtils";
import ConfirmationModal from "../ConfirmationModal";
import Portal from "../Portal";
import { CkeditorConfiguration } from "../../../smartCharts/CkEditorConfig";
import { MyUploadAdapterPlugin } from "../../../smartCharts/CustomImageUploadPlugin";

export const RichEditorPopup = ({
    label,
    value,
    onCancel,
    saveData,
    key,
    editorKey,
    isReadOnly = false,
    isSmartchart = false,
    isSurveyTemplate = false,
    outerClassName = "",
    onDataChange,
    saveLabel = "Save"
}) => {
    const ckEditorIdPrefix = editorKey != null && String(editorKey) !== "" ? String(editorKey) : key != null && String(key) !== "" ? String(key) : "rich-editor";
    const [data, setData] = useState(value);
    const [initialState, setInitialState] = useState(value);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);

    useEffect(() => {
        setData(value);
        setInitialState(value);
    }, [value]);

    const handleChange = data => {
        setData(data);
        if (typeof onDataChange === "function") onDataChange(data);
    };

    const handleSubmit = () => {
        if (typeof saveData === "function") saveData(data);
        onCancel();
    };

    const cancelForm = (e) => {
        e.stopPropagation();
        if (_.isEqual(initialState, data) || isReadOnly) {
            onCancel();
        } else {
            setShowConfirmationModal(true);
        }
    };

    const renderConfirmationModal = () => {
        if (!showConfirmationModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={"Do you want to cancel and lose all changes?"}
                        message={"This action cannot be reverted, are you sure that you need to cancel?"}
                        onNo={() => setShowConfirmationModal(false)}
                        onYes={() => onCancel()}
                        cancel={() => setShowConfirmationModal(false)}
                    />
                }
                onCancel={() => setShowConfirmationModal(false)}
            />
        );
    };

    return (
        <>
            <div
                id="modalId"
                className={`modal modal-region modal-img-magamnt ${isSmartchart ? "modal-text-band" : "modal-report-note"} ${
                    isSurveyTemplate ? "mod-gen-ins" : ""
                } modal-ck-edit modal-ck-editor-note`}
                style={{ display: "block", cursor: "move" }}
            >
                <Draggable cancel=".not-dragabble">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            {renderConfirmationModal()}
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={cancelForm}>
                                <span aria-hidden="true">
                                    <img src="/img/Group4.svg" alt="" />
                                </span>
                            </button>
                            <div className="modal-header d-flex align-items-center">
                                <h5 className="mb-0">{label}</h5>
                            </div>

                            <div className="modal-body region-otr not-dragabble">
                                <div className={`report-notes-txt  col-md-12 p-0 not-dragabble ${outerClassName ?? ""}`}>
                                    <CKEditor
                                        editor={Editor}
                                        // disabled={isReadOnly}
                                        config={
                                            isReadOnly
                                                ? { ...CkeditorConfiguration, toolbar: [] }
                                                : {
                                                      ...(isSmartchart
                                                          ? withParagraphTools(CkeditorConfiguration)
                                                          : CkeditorConfiguration),
                                                      extraPlugins: [MyUploadAdapterPlugin]
                                                  }
                                        }
                                        id={`${ckEditorIdPrefix}-edit-popup`}
                                        data={data || ""}
                                        onReady={editor => {
                                            if (editor) {
                                                editor?.plugins?.get("Notification")?.on("show:warning", (event, data) => {
                                                    event.stop();
                                                });
                                                editor.setData(data || "");
                                                const synced = editor.getData();
                                                setData(synced);
                                                setInitialState(synced);
                                                if (!isReadOnly) {
                                                    editor.focus();
                                                }
                                            }
                                            if (isReadOnly) {
                                                editor?.enableReadOnlyMode("my-feature-id");
                                            }
                                        }}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            handleChange(data);
                                        }}
                                        onBlur={(event, editor) => {}}
                                        onFocus={(event, editor) => {}}
                                    />
                                </div>
                            </div>
                            {!isReadOnly && (
                                <div className="modal-footer">
                                    <div className="btn-otr col-md-12 text-right p-0">
                                        <button type="button" onClick={cancelForm} className="btn btn-primary btnRgion btn-cancel mr-2">
                                            Cancel
                                        </button>
                                        <button type="button" onClick={handleSubmit} className="btn btn-primary btnRgion btn-save-round">
                                            {saveLabel}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </Draggable>
            </div>
        </>
    );
};
